import { useAppContext } from '../providers/AppProvider';

export const useUpdateUrlMobile = () => {
  const { trackingId, setTrackingId } = useAppContext();

  const updateTrackingId = (newTrackingId: string) => {
    setTrackingId(newTrackingId);
  };

  const updateUrlMobile = () => {
    window.location.hash = `tracking_id=${trackingId}`;
  };

  return { updateUrlMobile, updateTrackingId };
};
